import React from 'react'
import { FaUserPlus } from 'react-icons/fa'
import { AiOutlineStock } from 'react-icons/ai'
import { BsCodeSlash } from 'react-icons/bs'
import { AiOutlineBulb } from 'react-icons/ai'
export default function Plans() {
    return (
        <div className='py-[100px]'>
            <div className=" max-w-[1240px] mx-auto  md:grid md:grid-cols-3 gap-5">
                <div className="col-span-1 h-[500px] mx-auto p-2 shadow text-center hover:scale-110 gap-5  duration-500  ">
                    <FaUserPlus className='text-[60px] relative left-[50%] my-5' />
                    <h1 className='text-[30px] font-bold my-6'>Web Development</h1>
                    <h1 className=' my-5  text-[30px] font-bold'>$120</h1>
                    <p className=' my-5 font-bold'>new plan for</p>
                    <p className=' my-5 font-bold'>amaxing students</p>
                    <p className=' my-5 font-bold'>of the country</p>
                    <p className=' my-5 font-bold'>to get higher level</p>
                    <button type=' submit' className=' bg-green-700 hover:bg-gray-800 text-white font-bold py-2 mt-4 px-2 border border-blue-700 rounded'>Start Trial</button>

                </div>
                <div className="col-span-1 h-[500px] mx-auto p-2 shadow shadow-slate-500 text-center hover:scale-110 gap-5  duration-500  ">
                    <AiOutlineStock className='text-[60px] relative left-[50%] my-5' />
                    <h1 className='text-[30px] font-bold my-6'>Digital Marketing</h1>
                    <h1 className=' my-5  text-[30px] font-bold'>$150</h1>
                    <p className=' my-5 font-bold'>new plan for</p>
                    <p className=' my-5 font-bold'>amaxing students</p>
                    <p className=' my-5 font-bold'>of the country</p>
                    <p className=' my-5 font-bold'>to get higher level</p>
                    <button type=' submit' className=' bg-black hover:bg-green-800 text-white font-bold py-2 mt-4 px-2 border border-blue-700 rounded'>Start Trial</button>

                </div>                <div className="col-span-1 h-[500px] mx-5 p-2 shadow text-center hover:scale-110 gap-5  duration-500  ">
                    <BsCodeSlash className='text-[60px] relative left-[50%] my-5' />
                    <h1 className='text-[30px] font-bold my-6'>Programming  </h1>
                    <h1 className=' my-5  text-[30px] font-bold'>$170</h1>
                    <p className=' my-5 font-bold'>new plan for</p>
                    <p className=' my-5 font-bold'>amaxing students</p>
                    <p className=' my-5 font-bold'>of the country</p>
                    <p className=' my-5 font-bold'>to get higher level</p>
                    <button type=' submit' className=' bg-green-700 hover:bg-gray-800 text-white font-bold py-2 mt-4 px-2 border border-blue-700 rounded'>Start Trial</button>

                </div>

            </div>
        </div>
    )
}
